export const FLAG_ITINERARY_ADDITIONAL_FOOD_ACTIVITY =
  'FLAG_ITINERARY_ADDITIONAL_FOOD_ACTIVITY';
export const FLAG_ITINERARY_ADDITIONAL_FOODS =
  'FLAG_ITINERARY_ADDITIONAL_FOODS';
export const GET_ITINERARY_ADDITIONAL_FOODS = 'GET_ITINERARY_ADDITIONAL_FOODS';
export const CLEAR_ITINERARY_ADDITIONAL_FOODS =
  'CLEAR_ITINERARY_ADDITIONAL_FOODS';
